import { always, ifElse, isNil, pick } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { useSportsbookSelector } from '../../../../store';
import { selectEventField } from '../eventField';

export const selectEventFields = (eventId, fieldPath = [], fields = []) =>
  createSelector(
    selectEventField(eventId, fieldPath),
    ifElse(isNil, always({}), pick(fields))
  );

export const useEventFields = ({ eventId, fieldPath, fields }) =>
  useSportsbookSelector(
    selectEventFields,
    [eventId, fieldPath, fields],
    shallow
  );
